<template>
    <b-card-header
        :header-bg-variant="backgroundColor"
        :header-border-variant="borderColor"
        :header-class="headerClass"
        :header-text-variant="textColor"
        :style="style"
    >
        <slot />
    </b-card-header>
</template>

<script>
import { BCardHeader } from 'bootstrap-vue'

export default {
    components: { BCardHeader },
    computed: {
        style() {
            const opacity = '25'

            const style = {
                '--background-color-primary': `#007bff${opacity}`,
                '--background-color-secondary': `#6c757d${opacity}`,
                '--background-color-success': `#28a745${opacity}`,
                '--background-color-info': `#17a2b8${opacity}`,
                '--background-color-warning': `#ffc107${opacity}`,
                '--background-color-danger': `#dc3545${opacity}`,
                '--background-color-light': `#f8f9fa${opacity}`,
                '--background-color-dark': `#343a40${opacity}`,
                'background-color': `var(--background-color-${this.backgroundColor}) !important`,
            }

            if (this.backgroundColor) {
                style.border = 'none !important'
            }

            return style
        },
    },
    props: {
        backgroundColor: { type: String },
        borderColor: { type: String },
        headerClass: { type: String },
        textColor: { type: String },
    }
}
</script>